import { Region } from "./region";
import { Service } from "./service";
import { TypeHandicap } from "./typeHandicap";

export class Institution {
    id: number;
    repertoireFichier: string;
    smtpHost: string;
    smtpPswd: string;
    smtpUserName: string;
    smtpPort: number;
    gedHost: string;
    gedPswd: string;
    gedUsername: string;
    gedPort: number;
    gedSiteId: string;
    dateDebut: string;
    dateFin: string;
    dateDebutRA: string;
    dateFinRA: string;
    service: Service;
    region: Region;
    typeHandicap: TypeHandicap;
}

export enum TypeExportEnum {
    TOUT = 'TOUT',
	SERVICE = 'SERVICE',
	SERVICEREGION = 'SERVICEREGION',
	TYPEHANDICAP = 'TYPEHANDICAP',
}